import { useState } from "react";
import RightTimeApi from "@/API"; // Ensure you import RightTimeApi if it's used
import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";
import { toast } from "react-toastify";
import { apiMessage } from "@/utils/apiMessage";

export default function RolePermissionsTable(props) {

  if (!props || !props.lookups || !props.data || !Array.isArray(props.data.roleTests)) return null;

  async function toggleTestPermAsync(roleId, type) {
    let data = {
      companyId: props.activeTestType.companyId,
      companyTestTypeId: props.activeTestType.companyTestType.id,
      roleId: roleId,
      type: type,
    };
    const resp = await RightTimeApi.putAsync("/ToggleTestRolePermission", data);
    if (resp.ok) {
      toast.success(apiMessage(resp));
      props.updateData();
    };
  }
  return (
    <div className="tableWrapper factTable nohover inline-block rolePermissionTable">
      <table className="formTable">
        <caption>
          <span className="title">Role Permissions</span>
        </caption>
        <thead>
          <tr>
            <th>Role</th>
            <th>Permissions</th>
          </tr>
        </thead>
        <tbody>
          {props.lookups && props.lookups.roles
            ? props.lookups.roles.map((role) => {
              let canTake = props.data.roleTests.find(
                (roleTest) =>
                  roleTest.companyTestTypeId == props.activeTestType.companyTestType.id &&
                  roleTest.roleId === role.key &&
                  roleTest.canTake);
              let canCreate = props.data.roleTests.find(
                (roleTest) =>
                  roleTest.companyTestTypeId === props.activeTestType.companyTestType.id &&
                  roleTest.roleId === role.key &&
                  roleTest.canCreate
              );
              let canView = props.data.roleTests.find(
                (roleTest) =>
                  roleTest.companyTestTypeId === props.activeTestType.companyTestType.id &&
                  roleTest.roleId === role.key &&
                  roleTest.canView
              );
              return (
                <tr key={"ttRole" + role.key}>
                  <th>{role.value}</th>
                  <td className="left">
                    <div className="actionBlock" data-help-id="CanViewPermission">
                      <span className={`checkboxArea` + (canView ? " checked" : " unchecked")}>
                        {canView ? (
                          <MdCheckBox
                            className="checkbox checked actionIcon canViewCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "view")}
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            className="checkbox unchecked actionIcon canViewCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "view")}
                          />
                        )}
                        <span className="actionText">View</span>
                      </span>
                    </div>
                    <div className="actionBlock" data-help-id="CanCreatePermission">
                      <span className={`checkboxArea` + (canCreate ? " checked" : " unchecked")} >
                        {canCreate ? (
                          <MdCheckBox
                            className="checkbox checked actionIcon canCreateCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "create")}
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            className="checkbox unchecked actionIcon canCreateCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "create")}
                          />
                        )}
                        <span className="actionText">Create</span>
                      </span>
                    </div>
                    <div className="actionBlock" data-help-id="CanTakePermission">
                      <span className={`checkboxArea` + (canTake ? " checked" : " unchecked")}>
                        {canTake ? (
                          <MdCheckBox
                            className="checkbox checked actionIcon canTakeCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "take")}
                          />
                        ) : (
                          <MdCheckBoxOutlineBlank
                            className="checkbox unchecked actionIcon canTakeCheckbox"
                            data-id={role.key}
                            onClick={() => toggleTestPermAsync(role.key, "take")}
                          />
                        )}
                        <span className="actionText">Take</span>
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })
            : null}
        </tbody>
      </table>
    </div>
  );
}

